/**
 * Mobile Floating Reserve button — iter-51b.
 *
 * Always-visible "Réserver" pill at the bottom-center of the viewport on
 * mobile. Hidden inside any booking funnel so it never overlaps the
 * Suivant / Continuer / Payer CTA, and hidden on /staff/* (the layout
 * doesn't mount it there anyway).
 *
 * Behavior:
 *   - On the landing page (/) → smooth-scroll to #experiences.
 *   - Anywhere else → navigate to /#experiences (router-handled).
 *   - Discreet entry animation (slide-up + fade) on first paint.
 *   - Subtle press feedback (scale 0.97).
 */
import { useLocation, Link } from "react-router-dom";

const HIDDEN_PREFIXES = [
  "/booking/",
  "/reserver",
  "/cantine",
  "/enregistrement",
  "/univers/",
  "/event/",
  "/hebergement/",
  "/le-kaai",
];

export default function MobileBookFab() {
  const loc = useLocation();
  const hidden = HIDDEN_PREFIXES.some((p) => loc.pathname.startsWith(p));
  if (hidden) return null;

  const cls =
    "fixed left-1/2 -translate-x-1/2 z-40 lg:hidden " +
    "px-10 py-4 rounded-full text-[0.78rem] tracking-[0.32em] uppercase font-medium " +
    "bg-[#B8922A] text-white shadow-lg shadow-[#0A0A0A]/30 " +
    "hover:bg-[#D4AF37] active:scale-[0.97] transition-all duration-200 " +
    "animate-[fab-in_500ms_ease-out_both]";
  const style = {
    bottom: "calc(env(safe-area-inset-bottom, 0px) + 18px)",
  };

  if (loc.pathname === "/") {
    return (
      <a
        href="#experiences"
        onClick={(e) => {
          e.preventDefault();
          const el = document.getElementById("experiences");
          if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        }}
        className={cls}
        style={style}
        data-testid="mobile-fab-reserver"
      >
        Réserver
      </a>
    );
  }
  return (
    <Link
      to="/#experiences"
      className={cls}
      style={style}
      data-testid="mobile-fab-reserver"
    >
      Réserver
    </Link>
  );
}
